/**
 * User preferences utilities
 * Handles fetching and updating user preferences (currency, language)
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const getStoredToken = () => {
  return localStorage.getItem('auth_token');
};

/**
 * Get user preferences (currency, language)
 */
export const getUserPreferences = async () => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { currency: null, language: null };
    }

    const response = await fetch(`${API_BASE_URL}/api/user/preferences`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        // User preferences not found - return defaults
        return { currency: 'USD', language: 'en' };
      }
      throw new Error('Failed to fetch user preferences');
    }

    const data = await response.json();
    return {
      currency: data.currency || 'USD',
      language: data.language || 'en',
    };
  } catch (error) {
    console.error('Error fetching user preferences:', error);
    // Return defaults on error
    return { currency: 'USD', language: 'en' };
  }
};

/**
 * Update user preferences (currency, language)
 */
export const updateUserPreferences = async (preferences) => {
  try {
    const token = getStoredToken();
    if (!token) {
      throw new Error('Not authenticated');
    }

    const response = await fetch(`${API_BASE_URL}/api/user/preferences`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(preferences),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to update user preferences');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating user preferences:', error);
    throw error;
  }
};

